
const Anticipos = () => {
    return(
        <div>
            Anticipos
        </div>
    )
}

export default Anticipos;